import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const ResetPasswordEmailSent = ({ username }) => (
  <div className="d-grid gap-3">
    <h3 className="mb-3">Reset Password</h3>
    <div className="alert alert-info d-flex align-items-start" role="alert">
      <i className="fas fa-solid fa-circle-info icon__before-text text-info" />
      If an account exists for {username}, you will get an email with
      instructions on resetting your password. If it doesn&apos;t arrive, be
      sure to check your spam folder.
    </div>
    <div>
      <Link to="/account/login">Go back to login</Link>
    </div>
  </div>
);

export default ResetPasswordEmailSent;

ResetPasswordEmailSent.propTypes = {
  username: PropTypes.string,
};
